import { Title, Grid, Text, Stack } from '@mantine/core';
import { PageWithBreadcrumbs } from '../../components/layout/PageWithBreadcrumbs';
import { ContainerWhite } from '../../components/core';
import React, { useEffect, useState } from 'react';
import { AfaAnchor, AfaButton, AfaFieldDisplay, AfaSectionLoader } from '../../components/ui';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

// Página de ComunicacionesDetall - Gestión de ComunicacionesDetall oficiales
const ComunicacionesDetall = (props: any) => {

  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [communication, setCommunication] = useState(null as any);

  useEffect(() => {
    props.apiService.GetComunicaciones(props.entity.lookupId).then((data: any) => {
      const decodedTitle = decodeURIComponent(id || '');
      var filteredItem = data.filter((item: any) => item.title === decodedTitle);
      setCommunication(filteredItem.length > 0 ? filteredItem[0] : null);
      setLoading(false);
    })
      .catch((error: any) => {
        console.error("Error fetching ComunicacionesDetall:", error);
        setLoading(false);
      })
  }, []);

  return (
    <PageWithBreadcrumbs>
      <Title order={1}>{communication != null ? communication.title : 'Detall comunicació'}</Title>
      <Grid mt="md">
        <Grid.Col span={6}>
          <AfaButton id="btn-tornar" variant="outline" onClick={() => navigate('/comunicaciones')}>
            Tornar
          </AfaButton>
        </Grid.Col>
      </Grid>
      <ContainerWhite>
        {loading ? (
          <AfaSectionLoader message="Carregant comunicació..." />
        ) : (
          <div>
            <Grid mt="md">
              <Grid.Col span={6}>
                <AfaFieldDisplay
                  label="Contingut"
                  value={communication?.description}
                  style={{ flex: 1 }}
                />
              </Grid.Col>

              <Grid.Col span={6}>
                <AfaFieldDisplay
                  label="Data"
                  value={moment(communication?.communicationDate.toString()).format('DD/MM/YYYY')}
                  style={{ flex: 1 }}
                />
              </Grid.Col>
            </Grid>
            <p></p>
            <p></p>
            <Text size="lg" fw={600} mt="md">Contingut relacionat</Text>
            <Stack gap="md" mt="md">
              {communication != null && communication.links != null &&communication.links.map((item: any) => {
                return (
                  <AfaAnchor href={item.link} size="md">
                    {item.title}
                  </AfaAnchor>
                )
              })}
            </Stack>
          </div>
        )}
      </ContainerWhite>
    </PageWithBreadcrumbs>
  );
};

export default ComunicacionesDetall;
